var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkspaceProjectShare = function SvgIconWorkspaceProjectShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#686D8B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#icon_workspace_project_share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.294 9.166v-.625c0-1.647-1.208-1.913-2.347-2.333-.379-.14-.316-1.13-.149-1.314.393-.433.728-.94.728-2.166 0-1.237-.808-1.895-1.773-1.895-.966 0-1.773.658-1.773 1.894 0 1.226.333 1.733.727 2.166.167.185.23 1.174-.149 1.314C1.44 6.621.211 6.882.211 8.541v.625zM8.336 9.166h1.458v-.625c0-1.647-1.208-1.913-2.347-2.333-.379-.14-.316-1.13-.149-1.314.393-.433.728-.94.728-2.166 0-1.237-.808-1.895-1.773-1.895q-.21 0-.417.042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_workspace_project_share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
};
export default SvgIconWorkspaceProjectShare;